import { useQuery } from '@tanstack/react-query';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { LoadingSkeleton } from '../components/LoadingSkeleton';
import { api } from '../lib/api';

export function AuditLog() {
  const { data: entries, isLoading } = useQuery({
    queryKey: ['audit-phi'],
    queryFn: () => api.audit.phiAccess({ page: 1, per_page: 50 }),
  });

  return (
    <ErrorBoundary>
      <div className="space-y-4">
        <h1 className="text-xl font-semibold text-gray-900">Audit Log</h1>
        <p className="text-sm text-gray-500">
          Immutable PHI access and system event log. Retention: 7 years.
        </p>

        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
          {isLoading ? (
            <div className="p-6">
              <LoadingSkeleton />
            </div>
          ) : !entries || entries.length === 0 ? (
            <div className="p-6 text-center text-sm text-gray-400">No audit entries found.</div>
          ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50 text-left">
                  <th className="px-4 py-3 font-medium text-gray-600">Timestamp</th>
                  <th className="px-4 py-3 font-medium text-gray-600">Action</th>
                  <th className="px-4 py-3 font-medium text-gray-600">User</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {entries.map((entry) => (
                  <tr key={entry.id}>
                    <td className="px-4 py-3 font-mono text-xs text-gray-500">
                      {new Date(entry.created_at).toLocaleString()}
                    </td>
                    <td className="px-4 py-3 text-gray-700">{entry.action}</td>
                    <td className="px-4 py-3 font-mono text-xs text-gray-500">{entry.user_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </ErrorBoundary>
  );
}
